import React from 'react';

export const FacebookIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.1"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
        fill="white"
      />
      <path
        d="M22.325 9.12427H9.675C9.37078 9.12427 9.125 9.37005 9.125 9.67427V22.3243C9.125 22.6285 9.37078 22.8743 9.675 22.8743H22.325C22.6292 22.8743 22.875 22.6285 22.875 22.3243V9.67427C22.875 9.37005 22.6292 9.12427 22.325 9.12427ZM20.7369 13.1375H19.6386C18.7775 13.1375 18.6108 13.5466 18.6108 14.1482V15.4733H20.6664L20.3983 17.5479H18.6108V22.8743H16.4675V17.5496H14.6748V15.4733H16.4675V13.9436C16.4675 12.1682 17.552 11.2005 19.1367 11.2005C19.8964 11.2005 20.5478 11.2572 20.7386 11.283V13.1375H20.7369Z"
        fill="#F0F0F0"
      />
    </svg>
  );
};
